import React from 'react';

function Footer() {
    return (
        <div className="container-fluid bg-dark text-light" style={{ paddingTop: '40px' }}>
            <div className="container" id="footer-logos">
                <div className="row gx-5">
                    <div className="col-lg-4 col-md-6 footer-about">
                        <div className="d-flex flex-column align-items-center justify-content-evenly text-center h-100 bg-primary p-4">
                            <div className="navbar-brand">
                                <img src={require('../Images/logo-chg.png')} width="20%" alt="Logo CHG" /> &nbsp; &nbsp; &nbsp;
                                <img src={require('../Images/logo-liderar.png')} width="40%" alt="Logo Liderar" />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-12 pt-0 pt-lg-5 mb-5">
                        <div style={{ textAlign: 'center' }} className="pb-3 mb-4">
                            <a href="https://visitsalta.ar/">
                                <img style={{ paddingTop: '2em', right: '0' }} src={require('../Images/logo-salta-gobierno.png')} width="60%" alt="Logo Salta Gobierno" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid text-center text-white" id="end">
                <div className="row justify-content-end">
                    <div className="col">
                        <div className="d-flex align-items-end" style={{ height: '75px' }}>
                            <div className="col">
                                <figure className="text-center">
                                    <blockquote className="blockquote">
                                        <p className="h6" style={{ color: 'white' }}>Ministerio de Turismo y Deportes de Salta</p>
                                    </blockquote>
                                    <figcaption className="blockquote-footer" style={{ color: '#fd000a' }}>Dirección General de Informática</figcaption>
                                </figure>
                            </div>
                            <div className="col">
                                <figure className="text-center">
                                    <blockquote className="blockquote">
                                        <p className="h6" style={{ color: 'white' }}>Ministerio de Turismo y Deportes de Salta</p>
                                    </blockquote>
                                    <figcaption className="blockquote-footer" style={{ color: '#fd000a' }}>Dirección General Experiencias Turísticas</figcaption>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;